import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'//导入文件

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: "",
    user: null,
    role: null,
    regionCode: null,
    dateRange: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    communityList: []
  },
  getters: {
    getToken: (state) => {
      if (!state.token && localStorage.getItem("token")) {
        state.token = localStorage.getItem("token");
      }
      return state.token;
    },
    getUser: (state) => {
      if (!state.user && localStorage.getItem("user")) {
        state.user = JSON.parse(localStorage.getItem("user"));
      }
      return state.user;
    },
    getRole: (state) => {
      if (!state.role && localStorage.getItem("role")) {
        state.role = parseInt(localStorage.getItem("role"));
      }
      return state.role;
    },
    getRegionCode: (state) => {
      return state.regionCode;
    },
    getDateRange: (state) => {
      return state.dateRange;
    },
    getCommunityList: (state) => {
      return state.communityList;
    },
  },
  mutations: {
    setToken (state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    setUser (state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    setRole (state, role) {
      state.role = role;
      localStorage.setItem("role", role);
    },
    setRegionCode (state, regionCode) {
      state.regionCode = regionCode;
    },
    setDateRange (state, dateRange) {
      state.dateRange = dateRange;
    },
    setCommunityList (state, communityList) {
      state.communityList = communityList;
    },
  },
  actions: {
    setToken ({ commit }, token) {
      commit("setToken", token);
    },
    setUser ({ commit }, user) {
      commit("setUser", user);
    },
    setRole ({ commit }, role) {
      commit("setRole", role);
    },
    setRegionCode ({ commit }, regionCode) {
      commit("setRegionCode", regionCode);
    },
    setDateRange ({ commit }, dateRange) {
      commit("setDateRange", dateRange);
    },
    setCommunityList ({ commit }, communityList) {
      commit("setCommunityList", communityList);
    },
  },
  modules: {
  }
})
